/**
 * Returns the path to the CSS file for the mypages components. If a cache busted version is available, it will be used.
 * @returns {string} The path to the CSS file.
 */
export function getCssPath() {
    let styleHref = import.meta.env.PROD ? '/dist/mypages.bundle.css' : '/dist/src/app.css';
    return (window as any).cacheBustedMypagesCss || styleHref;
}
